import { Button, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import ItemStatus from "../../../../../../common/components/item_status";
import dayjs from "dayjs";

/**
 * GenerateFornecedorDocumentoColumnDefinition
 */

type Props = {
  onActionEditar: (idFornecedorArquivo: number | null, openState: boolean) => void;
  onActionDownload: (idFornecedorArquivo: number, nomeArquivo: string) => void;
  onActionDelete: (idFornecedorArquivo: number | null, openState: boolean) => void;
};

export const GenerateFornecedorDocumentoColumnDefinition = ({
  onActionEditar,
  onActionDownload,
  onActionDelete,
}: Props): GridColDef[] => {
  const computeStatusTitle = (status: number) => {
    switch (status) {
      case 2:
        return "Obsoleto";
      case 1:
        return "Atual";
      default:
        return "?";
    }
  };

  const computeStatusColor = (status: number) => {
    switch (status) {
      case 2:
        return "red";
      case 1:
        return "green";
      default:
        return "blue";
    }
  };

  const computeStatusDescription = (status: number) => {
    switch (status) {
      case 2:
        return "Obsoleto";
      case 1:
        return "Atual";
      default:
        return "?";
    }
  };

  return [
    {
      field: "status",
      filterable: false,
      headerName: "Tipo de Conta",
      minWidth: 80,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeStatusTitle(params.value)}
            color={computeStatusColor(params.value)}
            description={computeStatusDescription(params.value)} />
        </div>
      )
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "dataVencimento",
      filterable: false,
      headerName: "Data Vencimento",
      minWidth: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <span>{value && dayjs(value).format('DD/MM/YYYY')}</span>
        );
      }
    },
    {
      field: "nome",
      filterable: false,
      headerName: "Arquivo",
      flex: 1,
      minWidth: 60,
      sortable: false,
      valueGetter: (_, row) => [row['nome'], row['idFornecedorArquivo']],
      renderCell: ({ value: [nome, idFornecedorArquivo] }) => {
        return (
          <Button
            onMouseDown={() => { onActionDownload(idFornecedorArquivo, nome) }}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.3rem solid #4b8df8',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
            }}>
            {nome}
          </Button>
        );
      }
    },
    {
      field: 'idFornecedorArquivo',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: ({ value }) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => {
                onActionEditar(value, true);
                e.preventDefault();
              }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => { onActionDelete(value, true) }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}